export enum PaymentMethodEnum {
  Cash = 1,
  Card
}
